export const headerCellStyles = {
    color: '#444',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '700',
    background: '#DAEDFE',
    height: '36px',
    padding:'6px 12px'
}

export const cellStyles = {
    whiteSpace: 'nowrap',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    alignItems:'center',
    padding:'7px 12px',
    minHeight:'36px',
    color: '#444',
    // justifyContent: 'center',
    //  textAlign: 'center'
}
export const branchTypeList = [
    { id: 0, name: 'All', translationKey: 'gsAll' },
    { id: 1, name: 'Own', translationKey: 'rpOwn' },
    { id: 2, name: 'Other', translationKey: 'rpOther' },
]
export const monthNamesList = [
    {id:1,name:'January', translationKey: 'rpJanuary'},
    {id:2,name:'February', translationKey: 'rpFebruary'},
    {id:3,name:'March', translationKey: 'rpMarch'},
    {id:4,name:'April', translationKey: 'rpApril'},
    {id:5,name:'May', translationKey: 'rpMay'},
    {id:6,name:'June', translationKey: 'rpJune'},
    {id:7,name:'July', translationKey: 'rpJuly'},
    {id:8,name:'August', translationKey: 'rpAugust'},
    {id:9,name:'September', translationKey: 'rpSeptember'},
    {id:10,name:'October', translationKey: 'rpOctober'},
    {id:11,name:'November', translationKey: 'rpNovember'},
    {id:12,name:'December', translationKey: 'rpDecember'},
  ]
export const getYearList=(startYear,endYear)=>{
    let yearList = []
    for (let year = startYear; year <= endYear; year++) {
        let obj = {
          year: year
        };
        yearList.push(obj)
      }
      return yearList 
}
